import * as React from 'react';
import { SVGProps } from 'react';

const IconZoneOrangeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6.707V4.612l.184-.06.03-.01C2.958 4.292 3.837 4 5 4s2.042.293 2.786.541l.03.01C8.566 4.801 9.178 5 10 5c.81 0 1.524-.191 2.437-.435l.118-.031c.443-.118.92-.243 1.445-.341v2.041c-.313.07-.62.15-.93.232l-.179.048C12.032 6.744 11.081 7 10 7c-1.163 0-2.042-.293-2.786-.541l-.03-.01C6.434 6.199 5.822 6 5 6c-.822 0-1.434.199-2.184.449l-.03.01c-.245.082-.506.168-.786.248Z"
      fill="var(--color-typo-system)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9.707V7.612l.184-.06.03-.01C2.958 7.292 3.837 7 5 7s2.042.293 2.786.541l.03.01C8.566 7.801 9.178 8 10 8c.81 0 1.524-.191 2.437-.435l.118-.031c.443-.118.92-.243 1.445-.341v2.041c-.313.07-.62.15-.93.232l-.179.048c-.859.23-1.81.486-2.891.486-1.163 0-2.042-.293-2.786-.541l-.03-.01C6.434 9.199 5.822 9 5 9c-.822 0-1.434.199-2.184.449l-.03.01c-.245.082-.506.168-.786.248Z"
      fill="var(--color-typo-caution)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12.707v-2.095l.184-.06.03-.01C2.958 10.292 3.837 10 5 10s2.042.293 2.786.541l.03.01c.75.25 1.362.449 2.184.449.81 0 1.524-.191 2.437-.435l.118-.031c.443-.118.92-.243 1.445-.341v2.041c-.313.07-.62.15-.93.232l-.179.048c-.859.23-1.81.486-2.891.486-1.163 0-2.042-.293-2.786-.541l-.03-.01C6.434 12.199 5.822 12 5 12c-.822 0-1.434.199-2.184.449l-.03.01c-.245.082-.506.168-.786.248Z"
      fill="var(--color-typo-system)"
    />
  </svg>
);
export default IconZoneOrangeSizeS;
